import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { compararTallas, ordenarTallas } from "../../../../utils/tallas";

// Nuevo Corte (producción directa).
// Un solo paso: se elige el artículo, sus colores/tallas y las cantidades a cortar;
// al guardar se genera en automático la Orden de Corte + sus líneas, y sobre ella el
// Corte + sus artículos. Ya no hace falta capturar la orden por separado.
function CortesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  const URL_ARTICULOS_CORTES = process.env.REACT_APP_URL_ARTICULOS_CORTES;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");


  // Catálogos
  const [articulos, setArticulos] = useState([]);
  const [todosColores, setTodosColores] = useState([]);
  const [todasTallas, setTodasTallas] = useState([]);

  // Artículo y rejilla color x talla
  const [articuloSel, setArticuloSel] = useState(null);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [selectedColores, setSelectedColores] = useState([]);
  const [selectedTallas, setSelectedTallas] = useState([]);
  const [grid, setGrid] = useState([]); // [{colores, colorNombre, tallas, tallaNombre, cantidad}]

  // Datos de la orden (se generan en automático)
  const [numero, setNumero] = useState("NA");

  // Datos del corte
  const [fecha, setFecha] = useState(hoy);
  const [tiempoInicio, setTiempoInicio] = useState("");
  const [tiempoFin, setTiempoFin] = useState("");
  const [piezas, setPiezas] = useState(0);
  const [observaciones, setObservaciones] = useState("NA");
  const [consumoRealPrenda, setConsumoRealPrenda] = useState(0);
  // Campos del corte que ya no se capturan pero el modelo espera
  const mesa = 0;
  const lienzos = 0;
  const empalmes = 0;
  const retaceria = 0;
  const largoTrazo = 0;
  const responsable1 = "6275525ae9b2950360d3fa02";
  const responsable2 = "6275525ae9b2950360d3fa02";

  // Modal de captura por proporción
  const [modalProporcion, setModalProporcion] = useState(false);
  const toggleProporcion = () => setModalProporcion(!modalProporcion);
  const [colorProporcion, setColorProporcion] = useState("");
  const [totalProporcion, setTotalProporcion] = useState(0);
  const [proporciones, setProporciones] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios.get(URL_ARTICULOS, { headers }).then((res) => setArticulos(res.data)).catch(console.log);
    axios.get(URL_COLORES, { headers }).then((res) => setTodosColores(res.data)).catch(console.log);
    axios.get(URL_TALLAS, { headers }).then((res) => setTodasTallas(res.data)).catch(console.log);
  }, []); // eslint-disable-line

  // Reconstruye la rejilla color x talla conservando cantidades ya capturadas
  function rebuildGrid(cols, tals, prevGrid) {
    const nuevo = [];
    cols.forEach((c) => {
      tals.forEach((t) => {
        const prev = (prevGrid || []).find(
          (g) => g.colores === c._id && g.tallas === t._id
        );
        nuevo.push({
          colores: c._id,
          colorNombre: c.name,
          tallas: t._id,
          tallaNombre: t.name,
          cantidad: prev ? prev.cantidad : 0,
        });
      });
    });
    setGrid(nuevo);
  }

  // Al elegir un artículo, despliega sus colores y tallas en una rejilla
  function seleccionaArticulo(art) {
    setArticuloSel(art);
    if (!art) {
      setColores([]);
      setTallas([]);
      setGrid([]);
      setSelectedColores([]);
      setSelectedTallas([]);
      setNumero("NA");
      return;
    }
    // El número de la orden se llena con el código del artículo
    setNumero(art.codigo || art.codigoCliente || "NA");
    const cols = art.colores || [];
    const tals = art.tallas || [];
    setColores(cols);
    setTallas(tals);
    setSelectedColores(cols);
    setSelectedTallas(tals);
    rebuildGrid(cols, tals, []);
  }

  function cambiaColores(sel) {
    setSelectedColores(sel);
    setColores(sel);
    rebuildGrid(sel, selectedTallas, grid);
  }

  function cambiaTallas(sel) {
    setSelectedTallas(sel);
    setTallas(sel);
    rebuildGrid(selectedColores, sel, grid);
  }

  // Guarda los colores/tallas elegidos en el artículo (los deja asignados a futuro)
  function asignarAlArticulo(campo, lista) {
    if (!articuloSel) return;
    if (!lista.length) {
      Swal.fire({ icon: "warning", title: `Selecciona al menos un ${campo === "colores" ? "color" : "talla"}` });
      return;
    }
    axios
      .patch(
        `${URL_ARTICULOS}/${articuloSel._id}`,
        { [campo]: lista.map((x) => x._id) },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => Swal.fire("Listo", `${campo === "colores" ? "Colores" : "Tallas"} asignados al artículo`, "success"))
      .catch((err) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "No se pudieron asignar" });
        console.log(err);
      });
  }

  function cambiaCantidad(idColor, idTalla, valor) {
    // Si se captura el PRIMER color, se replica esa cantidad a todos los colores
    // (misma talla). Los demás colores se pueden editar individualmente después.
    const esPrimerColor = colores.length > 0 && colores[0]._id === idColor;
    setGrid((prev) =>
      prev.map((g) => {
        if (esPrimerColor && g.tallas === idTalla) return { ...g, cantidad: valor };
        if (g.colores === idColor && g.tallas === idTalla) return { ...g, cantidad: valor };
        return g;
      })
    );
  }

  function abreProporcion(idColor) {
    setColorProporcion(idColor);
    setTotalProporcion(0);
    setProporciones(
      ordenarTallas(tallas).map((t) => ({ tallas: t._id, tallaNombre: t.name, proporcion: 0 }))
    );
    toggleProporcion();
  }

  function cambiaProporcion(idTalla, valor) {
    setProporciones((prev) =>
      prev.map((p) => (p.tallas === idTalla ? { ...p, proporcion: valor } : p))
    );
  }

  function aplicaProporcion() {
    const suma = proporciones.reduce(
      (t, p) => t + (parseFloat(p.proporcion) || 0),
      0
    );
    if (suma <= 0 || totalProporcion <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Captura el total y al menos una proporción.",
      });
      return;
    }
    setGrid((prev) =>
      prev.map((g) => {
        if (g.colores !== colorProporcion) return g;
        const prop = proporciones.find((p) => p.tallas === g.tallas);
        const p = prop ? parseFloat(prop.proporcion) || 0 : 0;
        return { ...g, cantidad: Math.round((totalProporcion * p) / suma) };
      })
    );
    toggleProporcion();
  }

  const totalPiezas = grid.reduce((t, g) => t + (parseFloat(g.cantidad) || 0), 0);

  const saveCorte = async (event) => {
    event.preventDefault();
    if (!articuloSel) {
      Swal.fire({ icon: "warning", title: "Selecciona un artículo" });
      return;
    }
    if (!fecha) {
      Swal.fire({ icon: "warning", title: "Captura la fecha del corte" });
      return;
    }
    if (totalPiezas <= 0) {
      Swal.fire({ icon: "warning", title: "Captura cantidades a cortar" });
      return;
    }
    setValidaBoton(false);
    toggleProgreso();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const lineas = grid.filter((g) => parseFloat(g.cantidad) > 0);

    try {
      // 1) Orden de corte en automático (producción directa, ya cortada)
      const dataOrden = await axios.post(
        URL_ORDENES_CORTE,
        {
          fecha,
          cantidad: totalPiezas,
          observaciones,
          numero,
          cortado: "Si",
          articulos: articuloSel._id,
          sinPedido: "Si",
          estado: "Cortado",
        },
        { headers }
      );
      const idOrden = dataOrden.data._id;
      const numeroOrden = `${dataOrden.data.numero || dataOrden.data.idOrdenesCorte || ""}`;

      // 2) Una línea de la orden por cada color/talla con cantidad
      const lineasOrden = [];
      for (const g of lineas) {
        const dataLinea = await axios.post(
          URL_ARTICULOS_ORDENES_CORTE,
          {
            ordenesCorte: idOrden,
            articulos: articuloSel._id,
            colores: g.colores,
            tallas: g.tallas,
            cantidad: parseFloat(g.cantidad),
            pendiente_cortar: parseFloat(g.cantidad),
            cortado: 0,
            estado: "Pendiente Corte",
            numeroOrden,
          },
          { headers }
        );
        lineasOrden.push({ ...g, idLineaOrden: dataLinea.data._id });
      }

      // 3) Corte sobre esa orden
      const dataCorte = await axios.post(
        URL_CORTES,
        {
          fecha,
          mesa,
          ordenesCorte: idOrden,
          total_cantidad: totalPiezas,
          lienzos,
          piezas: parseFloat(piezas) || 0,
          observaciones: observaciones || "NA",
          consumoRealPrenda: parseFloat(consumoRealPrenda) || 0,
          empalmes,
          retaceria,
          largoTrazo,
          tiempoInicio,
          tiempoFin,
          responsable1,
          responsable2,
          status: "Abierto",
          articulos: articuloSel._id,
        },
        { headers }
      );
      const idCorte = dataCorte.data._id;

      // Liga telas apartadas a la orden (si las hubiera); no bloquea el flujo
      await axios
        .patch(
          `${URL_INVENTARIOS_TELAS}/cortesCreate/${idOrden}`,
          { cortes: idCorte },
          { headers }
        )
        .catch(() => {});

      // 4) Artículos del corte (el back marca cortado/pendiente en la línea de la orden)
      for (const l of lineasOrden) {
        await axios.post(
          URL_ARTICULOS_CORTES,
          {
            cortes: idCorte,
            articulosOrdenesCorte: l.idLineaOrden,
            articulos: articuloSel._id,
            colores: l.colores,
            tallas: l.tallas,
            total_cantidad: parseFloat(l.cantidad),
            cantidad_procesos: parseFloat(l.cantidad),
            faltanteRecibir: parseFloat(l.cantidad),
            fecha,
            estado: "Cortado",
          },
          { headers }
        );
      }

      axios.post(
        URL_LOGS,
        {
          tipo: "Crear Corte",
          detalle: `Corte ${idCorte} / Orden ${numeroOrden} (automática)`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire("Listo", `Corte registrado con éxito (orden ${numeroOrden})`, "success");
      setTimeout(() => {
        window.location.reload();
      }, 1200);
    } catch (error) {
      toggleProgreso();
      const detalle =
        error.response && error.response.data
          ? typeof error.response.data === "string"
            ? error.response.data
            : JSON.stringify(error.response.data)
          : "";
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: detalle,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <>
      <Header />
      <br />
      {user.menu_produccion ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cut" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Nuevo Corte
              </h3>
              <p className="page-subtitle">
                Selecciona artículo, captura cantidades por color/talla y los datos del corte.
                La orden de corte se genera en automático.
              </p>
            </div>
          </div>

          <Form onSubmit={saveCorte}>
            {/* Datos generales */}
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-info-circle" />
                <span className="form-section-title">Datos Generales</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={4}>
                    <Label>Artículo</Label>
                    <Autocomplete
                      size="small"
                      value={articuloSel}
                      onChange={(event, sel) => seleccionaArticulo(sel)}
                      options={articulos.sort((a, b) =>
                        (a.codigo || "") > (b.codigo || "") ? 1 : -1
                      )}
                      getOptionLabel={(option) =>
                        option ? `${option.codigo} ${option.descripcion || ""}` : ""
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona artículo" variant="outlined" />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha Corte</Label>
                    <Input
                      type="date"
                      value={fecha}
                      required
                      onChange={(e) => setFecha(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Número Orden</Label>
                    <Input
                      type="text"
                      value={numero}
                      onChange={(e) => setNumero(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label>Observaciones</Label>
                    <Input
                      type="text"
                      value={observaciones}
                      onChange={(e) => setObservaciones(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label>Hora Inicio</Label>
                    <Input
                      type="datetime-local"
                      value={tiempoInicio}
                      onChange={(e) => setTiempoInicio(e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Hora Fin</Label>
                    <Input
                      type="datetime-local"
                      value={tiempoFin}
                      onChange={(e) => setTiempoFin(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Piezas</Label>
                    <Input
                      type="number"
                      min="0"
                      value={piezas}
                      onChange={(e) => setPiezas(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Consumo Real x Prenda</Label>
                    <Input
                      type="text"
                      value={consumoRealPrenda}
                      onChange={(e) => setConsumoRealPrenda(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            {/* Colores */}
            {articuloSel && (
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-palette" />
                  <span className="form-section-title">Colores</span>
                </div>
                <div className="form-section-body">
                  <Row className="align-items-end">
                    <Col md={9}>
                      <Label>Colores del corte</Label>
                      <Autocomplete
                        multiple
                        size="small"
                        value={selectedColores}
                        onChange={(event, sel) => cambiaColores(sel)}
                        options={todosColores.sort((a, b) =>
                          (a.name || "") > (b.name || "") ? 1 : -1
                        )}
                        getOptionLabel={(o) => o.name || ""}
                        getOptionSelected={(o, v) => o._id === v._id}
                        renderInput={(params) => (
                          <TextField {...params} label="Selecciona colores" variant="outlined" />
                        )}
                      />
                    </Col>
                    <Col md={3}>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => asignarAlArticulo("colores", selectedColores)}
                      >
                        <i className="fas fa-save" style={{ marginRight: 6 }} />
                        Asignar al artículo
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            {/* Tallas */}
            {articuloSel && (
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-ruler-horizontal" />
                  <span className="form-section-title">Tallas</span>
                </div>
                <div className="form-section-body">
                  <Row className="align-items-end">
                    <Col md={9}>
                      <Label>Tallas del corte</Label>
                      <Autocomplete
                        multiple
                        size="small"
                        value={selectedTallas}
                        onChange={(event, sel) => cambiaTallas(sel)}
                        options={ordenarTallas(todasTallas)}
                        getOptionLabel={(o) => o.name || ""}
                        getOptionSelected={(o, v) => o._id === v._id}
                        renderInput={(params) => (
                          <TextField {...params} label="Selecciona tallas" variant="outlined" />
                        )}
                      />
                    </Col>
                    <Col md={3}>
                      <Button
                        type="button"
                        color="primary"
                        onClick={() => asignarAlArticulo("tallas", selectedTallas)}
                      >
                        <i className="fas fa-save" style={{ marginRight: 6 }} />
                        Asignar al artículo
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            {/* Cantidades a cortar */}
            {articuloSel && (
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-list" />
                  <span className="form-section-title">Cantidades a Cortar</span>
                </div>
                <div className="form-section-body">
                  {colores.length === 0 || tallas.length === 0 ? (
                    <p style={{ color: "#94a3b8" }}>
                      El artículo necesita colores y tallas asignados.
                    </p>
                  ) : (
                    colores.map((col) => (
                      <div key={col._id} style={{ marginBottom: 14 }}>
                        <Row className="align-items-end">
                          <Col md={2}>
                            <strong>{col.name}</strong>
                            <br />
                            <Button
                              size="sm"
                              color="primary"
                              type="button"
                              style={{ marginTop: 4 }}
                              onClick={() => abreProporcion(col._id)}
                            >
                              <i className="fas fa-percentage" style={{ marginRight: 4 }} />
                              Proporción
                            </Button>
                          </Col>
                          {grid
                            .filter((g) => g.colores === col._id)
                            .sort((a, b) => {
                              return compararTallas(a.tallaNombre, b.tallaNombre);
                            })
                            .map((g) => (
                              <Col md={1} key={g.tallas}>
                                <Label>{g.tallaNombre}</Label>
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  value={g.cantidad}
                                  onChange={(e) =>
                                    cambiaCantidad(g.colores, g.tallas, e.target.value)
                                  }
                                />
                              </Col>
                            ))}
                        </Row>
                      </div>
                    ))
                  )}
                  <Row>
                    <Col md={12}>
                      <h4 style={{ marginTop: 10 }}>
                        TOTALES {new Intl.NumberFormat("en-US").format(totalPiezas)} pzas.
                      </h4>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            <div className="submit-bar">
              <Button href="/ListadoCortes" className="btn btn-danger" id="botonListado">
                Regresar
              </Button>
              <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            </div>
          </Form>

          {/* Modal de captura por proporción */}
          <Modal isOpen={modalProporcion} toggle={toggleProporcion}>
            <ModalHeader toggle={toggleProporcion}>
              <i className="fas fa-percentage" style={{ marginRight: 8, color: "#3b82f6" }} />
              Captura por proporción
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label>Total a repartir</Label>
                  <Input
                    type="number"
                    min="0"
                    value={totalProporcion}
                    onChange={(e) => setTotalProporcion(parseFloat(e.target.value) || 0)}
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                {proporciones.map((p) => (
                  <Col md={3} key={p.tallas} style={{ marginBottom: 8 }}>
                    <Label>{p.tallaNombre}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      value={p.proporcion}
                      onChange={(e) => cambiaProporcion(p.tallas, e.target.value)}
                    />
                  </Col>
                ))}
              </Row>
              <p style={{ fontSize: "0.75rem", color: "#64748b", marginTop: 8 }}>
                La cantidad de cada talla = Total × (proporción de la talla ÷ suma de
                proporciones).
              </p>
              <div className="submit-bar">
                <Button color="secondary" type="button" onClick={toggleProporcion}>
                  Cancelar
                </Button>
                <Button color="success" type="button" onClick={aplicaProporcion}>
                  Aplicar
                </Button>
              </div>
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default CortesCreate;
